import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { useUserStore } from '@/stores/user'

// Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// 样式
import './assets/styles/index.scss'

// 工具库
import './utils/directive'

// 创建 Pinia 实例
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// 抑制 ResizeObserver 错误警告（避免显示在页面上）
const resizeObserverLoopErrRe = /^ResizeObserver loop completed with undelivered notifications\./
const resizeObserverLoopErr = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends resizeObserverLoopErr {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        callback(entries, observer)
      })
    })
  }
}

// 额外的错误处理
window.addEventListener('error', (e) => {
  if (resizeObserverLoopErrRe.test(e.message)) {
    e.stopImmediatePropagation()
    e.preventDefault()
  }
})

window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && resizeObserverLoopErrRe.test(e.reason.message)) {
    e.stopImmediatePropagation()
    e.preventDefault()
  }
})

const app = createApp(App)

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 全局配置
app.config.globalProperties.$ELEMENT = {
  size: 'default',
  zIndex: 3000
}

// 错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue错误:', err, info)
  // 可以发送错误到监控系统
}

// 性能监控
if (process.env.NODE_ENV === 'development') {
  app.config.performance = true
}

app.use(pinia)
app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
  size: 'default'
})

// 初始化用户store，将pinia持久化恢复的token同步到axios请求头
const userStore = useUserStore()
userStore.init()

app.mount('#app')

// 首屏路由组件解析后立即收起进度线；接口、图片和各区块数据继续异步加载。
// 这样既避免空白闪烁，也不会因为后台请求或 window.load 延迟而显示全屏遮罩。
router.isReady().then(() => {
  window.dispatchEvent(new Event('app-ready'))
})

export default app
